module.exports = __webpack_public_path__ + "public/images/wallet-cta.2773e3f9ed7bf925d72ca3e8935a0e7c.svg";